import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { loadSectionTexts } from "../../utils/contentService";
import heroBgMobile from "../../assets/imgs/hero-bg-mobile.jpg";

export default function InvitationSection() {
  const { i18n } = useTranslation();
  const [texts, setTexts] = useState({});

  useEffect(() => {
    setTexts(loadSectionTexts("invitation", i18n.language));
  }, [i18n.language]);

  return (
    <section className="w-full py-12 md:py-16 lg:py-24 bg-test">
      <div className="mx-auto max-w-[1100px] px-4">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-12 xl:gap-[75px]">
          {/* Left side - Decorative background (hidden on mobile) */}
          <div
            className="hidden lg:block w-[466px] h-[605px] shrink-0 bg-contain bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${heroBgMobile})` }}
          />

          {/* Right side - Content Container with centered wrapper */}
          <div className="w-full lg:w-[617px] flex justify-center">
            <div className="w-full max-w-[617px] min-w-[280px] lg:h-[605px] flex flex-col justify-between gap-8 lg:gap-0">
              {/* Top Right Headline */}
              <h2 className="text-[30px] lg:text-[45px] font-normal font-serif italic leading-tight lg:leading-[50px] text-black text-right self-end max-w-full">
                {texts.headline1 || ""} <br />
                {texts.headline2 || ""}
                <br />
                {texts.headline3 || ""}
              </h2>

              {/* Bottom Left Text Group */}
              <div className="text-[13px] lg:text-[25px] font-light font-serif italic leading-relaxed lg:leading-[40px] text-black text-left self-start max-w-full space-y-4 lg:space-y-8">
                {/* Invitation Text */}
                <p>
                  {texts.text1 || ""}
                  <br />
                  <br />
                  {texts.text3 || ""}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
